export default __webpack_public_path__ + "static/media/validator.daef4485.svg";